import Router from 'vue-router'
import Vue from 'vue'
import config from './config'
Vue.use(Router)
export function loadView(view: string): any {
  // return require(`./pages/${view}.vue`).default
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `./pages/${view}.vue`)
  /**
   * 这里有个情况，在ios下测试使用() => import或require方式没有问题
   * 在Android微信下由于把组件也划分为一个单独的JS文件，部分手机会报503错误
   * 但是() => import或require方式在测试环境不会报错，报503错仅出现在正式环境
   */
}
export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  base: config.app_name,
  routes: [
    {
      path: '/',
      alias: 'index',
      component: () => import('./pages/index.vue'), // loadView('index'),
      name: '首页',
    },
    {
      path: '/jump',
      component: () => import('./pages/jump/index.vue'),
      name: '添加常爸福利官',
    },
    {
      path: '/h5WordTest',
      name: '单词测试',
      component: () => import('./pages/wordtest/post.vue'), // loadView('wordtest/post'),
    },
    {
      path: '/h5nameChild',
      component: () => import('./pages/namechild/post.vue'), // loadView('namechild/post'),
      name: '起名活动',
    },
    {
      path: '/h5nameResult',
      component: () => import('./pages/namechild/result.vue'), // loadView('namechild/result'),
      name: '起名结果',
    },
    {
      path: '/vTest',
      component: () => import('./pages/vegetable/index.vue'), // loadView('vegetable/index'),
      name: '蔬菜测试首页',
    },
    {
      path: '/vTestRes',
      component: () => import('./pages/vegetable/result.vue'), // loadView('vegetable/result'),
      name: '蔬菜测试结果页',
    },
    {
      path: '/vTestQa',
      component: () => import('./pages/vegetable/test.vue'), // loadView('vegetable/test'),
      name: '蔬菜测试测试页',
    },
    {
      path: '/disclaimer',
      component: () => import('./pages/disclaimer/index.vue'), // loadView('disclaimer/index'),
      name: '免责声明',
    },
    {
      path: '/privacy',
      component: () => import('./pages/appPrivacy/index.vue'), // loadView('appPrivacy/index'),
      name: 'app隐私政策',
    },
    {
      path: '/baiduLogin',
      component: () => import('./pages/baiduLogin/index.vue'), // loadView('baiduLogin/index'),
      name: '百度登录',
    },
    {
      path: '/luckdraw',
      component: () => import('./pages/luckDraw/post.vue'), // loadView('luckDraw/post'),
      name: '抽奖活动',
    },
    {
      path: '/login',
      component: () => import('./pages/login/login.vue'), // loadView('topics/course'),
      name: '登陆注册',
    },
    {
      path: '/admin/appdownload',
      // children: require('./pages/admin/index').default,
      component: () => import('./pages/admin/appdownload.vue'), // loadView('topics/course'),
      name: '付费抽奖',
    },
    {
      path: '/test/ua',
      component: () => import('./pages/test/ua.vue'), // loadView('topics/course'),
      name: '付费抽奖',
    },
    {
      path: '*',
      name: '错误页',
      component: () => import('./pages/components/error.vue'), // loadView('components/error'),
    },
    {
      path: '/comopleteReceiver', // 帮助用户补充实物订单收货地址
      component: () => import('./pages/comopleteReceiver.vue'),
      name: '常青藤爸爸',
    },
  ],
})
